// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"0934d14d","229":"4f511f2e","255":"cb78c6ae","326":"0d1a3133","329":"582d6296","381":"a74694f0","422":"88a2a6a4","538":"0d0d65c9","602":"c6db76ae","647":"9dfaa63d","652":"4469b187","715":"78cd5bf3","958":"f1d3f46a"}[chunkId] + ".chunk.js";
};